// extracted by mini-css-extract-plugin
module.exports = {"container":"az_hPc","promptText":"az_iPc","promptLabel":"az_jPc","closeButton":"az_kPc","srOnly":"az_lPc"};